<template>
  <div class="my-order" ref="container">
    <div class="header bg-color-red">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="text" style="margin-top: 0.4rem;">
          <div class="name">核销信息</div>
          <!-- <div>累计核销：{{ userInfo.hx_yj || 0 }}</div> -->
          <div style="color: #fff;font-size: .28rem;">
            总金额：{{ orderBadge.total_price || 0 }}
          </div>
          <div style="color: #fff;font-size: .28rem;">
            单数：{{ orderBadge.total || 0 }}
          </div>
          <div style="color: #fff;font-size: .28rem;">
            产品数：{{ orderBadge.goods_num || 0 }}
          </div>
        </div>
        <div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
      </div>
    </div>
    <div class="list flex flex_between">
      <div
        class="item flex ali_center flex_center"
        @click="date_show1 = true"
        style="width: 40%;text-align: center;"
      >
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ certStartTime || "开始时间" }}
        </div>
      </div>
      <div
        class="item flex ali_center flex_center"
        @click="date_show2 = true"
        style="width: 40%;"
      >
        <div class="uni-input" style="line-height: 0.99rem;height: 0.99rem;">
          {{ bussAuthEndTime || "结束时间" }}
        </div>
      </div>
    </div>
    <div class="list">
      <div class="item" v-for="order in orderList" :key="order.id">
        <div class="title acea-row row-between-wrapper">
          <div class="acea-row row-middle">订单号： {{ order.order_id }}</div>
          <div style="color: #0e98fd;">
            {{ order.istypedy == 10 ? "旧云仓订单" : "新云仓订单" }}
          </div>
        </div>
        <div>
          <div class="item-info acea-row row-between row-top">
            <div class="pictrue">
              <img :src="order._info[0].cart_info.productInfo.image" />
            </div>
            <div class="text acea-row row-between">
              <div class="name line2">
                {{ order._info[0].cart_info.productInfo.store_name }}
              </div>
              <div class="money">
                <div v-if="order.istypedy != 10">
                  ￥{{ order._info[0].cart_info.truePrice }}
                </div>
                <div>x{{ order._info[0].cart_info.cart_num }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="totalPrice">
          共{{ order._info.length || 0 }}件商品<span
            v-if="order.total_price > 0 && order.istypedy != 10"
            >，总金额</span
          >
          <span
            class="money icon-color"
            v-if="order.total_price > 0 && order.istypedy != 10"
            >￥{{ order.total_price }}</span
          >
        </div>
        <div class="bottom acea-row row-middle" style="height: 0.6rem;">
          核销时间：{{ order.hx_time }}
        </div>
        <div
          class="bottom acea-row row-middle"
          style="height: 0.6rem;"
          v-if="order.nickname"
        >
          下单人：{{ order.nickname }}
        </div>
        <!--  <template v-if="order._status._type === 0">
            <div class="bnt bg-color-red" @click="paymentTap(order)">
              立即付款
            </div>
          </template>
          <template
            v-if="order._status._type === 1 || order._status._type === 9"
          >
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              查看详情
            </div>
          </template>
          <template v-if="order._status._type === 2">
            <div
              class="bnt default"
              @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              "
              v-if="order.delivery_type === 'express'"
            >
              查看物流
            </div>
            <div class="bnt bg-color-red" @click="takeOrder(order)">
              确认收货
            </div>
          </template>
          <template v-if="order._status._type === 3">
            <div
              class="bnt default"
              @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              "
              v-if="order.delivery_type === 'express'"
            >
              查看物流
            </div>
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              去评价
            </div>
          </template>
          <template v-if="order._status._type === 4">
            <div
              class="bnt bg-color-red"
              @click="$router.push({ path: '/order/detail/' + order.order_id })"
            >
              查看订单
            </div>
          </template>
        </div> -->
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.lsjf"
    ></Payment>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
    <div class="mask" v-if="date_show1" @click="date_show1 = false"></div>
    <div v-if="date_show1" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange1"
        @cancel="date_show1 = false"
      >
      </DatetimePicker>
    </div>
    <div class="mask" v-if="date_show2" @click="date_show2 = false"></div>
    <div v-if="date_show2" class="DatetimePicker">
      <DatetimePicker
        type="date"
        v-model="DatecertStartTime3"
        :min-date="startDate"
        :max-date="endDate"
        title="请选择时间"
        @confirm="bindDateChange2"
        @cancel="date_show2 = false"
      >
      </DatetimePicker>
    </div>
  </div>
</template>

<script>
// import { getOrderData, getOrderList } from "@api/order";
import { hxOrderLog, getUser, hxOrderBadge } from "@api/user";
import {
  cancelOrderHandle,
  payOrderHandle,
  takeOrderHandle
} from "@libs/order";
import Loading from "@components/Loading";
import Payment from "@components/Payment";
// import { mapGetters } from "vuex";
import { isWeixin } from "@utils";
import GeneralWindow from "@components/GeneralWindow";
import { DatetimePicker } from "vant";

// const STATUS = [
//   "待付款",
//   "待发货",
//   "待收货",
//   "待评价",
//   "已完成",
//   "",
//   "",
//   "",
//   "",
//   "待付款"
// ];

const NAME = "MyOrder";

export default {
  name: NAME,
  data() {
    return {
      DatecertStartTime3: new Date(),
      startDate: new Date(1900, 1, 1),
      endDate: new Date(2100, 1, 1),
      date_show1: false,
      date_show2: false,
      certStartTime: "",
      bussAuthEndTime: "",
      userInfo: {},
      orderBadge: {},
      offlinePayStatus: 2,
      orderData: {},
      type: parseInt(this.$route.params.type) || 0,
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      orderList: [],
      pay: false,
      payType: ["yue", "weixin", "alipay", "lsjf"],
      // payType: ["yue"],
      from: isWeixin() ? "weixin" : "weixinh5",
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  components: {
    Loading,
    Payment,
    GeneralWindow,
    DatetimePicker
  },
  // computed: mapGetters(["userInfo"]),
  watch: {
    $route(n) {
      if (n.name === NAME) {
        const type = parseInt(this.$route.params.type) || 0;
        if (this.type !== type) {
          this.changeType(type);
        }
        this.getOrderData();
      }
    }
  },
  methods: {
    bindDateChange1: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.certStartTime = year + "-" + month + "-" + date;
      this.date_show1 = false;
      if (this.bussAuthEndTime) {
        this.orderList = [];
        this.page = 1;
        this.loaded = false;
        this.loading = false;
        this.gethxOrderBadge();
        this.getOrderList();
      }
    },
    bindDateChange2: function(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      let date = e.getDate();
      this.bussAuthEndTime = year + "-" + month + "-" + date;
      this.date_show2 = false;
      if (this.certStartTime) {
        this.orderList = [];
        this.page = 1;
        this.loaded = false;
        this.loading = false;
        this.gethxOrderBadge();
        this.getOrderList();
      } else {
        this.$dialog.error("请选择开始时间");
      }
    },
    gethxOrderBadge() {
      hxOrderBadge({
        data:
          this.bussAuthEndTime && this.certStartTime
            ? this.certStartTime + " - " + this.bussAuthEndTime
            : ""
      }).then(res => {
        this.orderBadge = res.data;
      });
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
      });
    },
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1) {
        if (that.payType.indexOf("offline") < 0) {
          that.payType.push("offline");
        }
      }
    },
    // getOrderData() {
    //   getOrderData().then(res => {
    //     this.orderData = res.data;
    //   });
    // },
    takeOrder(order) {
      this.$dialog.loading.open("正在加载中");
      takeOrderHandle(order.order_id)
        .then(res => {
          if (
            (res.data.gain_integral != "0.00" &&
              res.data.gain_coupon != "0.00") ||
            (res.data.gain_integral > 0 && res.data.gain_coupon > 0)
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券以及${res.data.gain_integral}积分，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠礼包"
            };
            return;
          } else if (
            res.data.gain_integral != "0.00" ||
            res.data.gain_integral > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_integral}积分，购买商品时可抵现哦～`,
              title: "赠送积分"
            };
            return;
          } else if (
            res.data.gain_coupon != "0.00" ||
            res.data.gain_coupon > 0
          ) {
            this.$dialog.loading.close();
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠券"
            };
            return;
          } else {
            this.$dialog.loading.close();
            this.$dialog.success("收货成功");
          }
          this.getOrderData();
          this.orderList = [];
          this.page = 1;
          this.loaded = false;
          this.loading = false;
          this.getOrderList();
        })
        .catch(err => {
          this.$dialog.loading.close();
          this.$dialog.error(err.msg);
        });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.reload();
      this.getOrderData();
    },
    reload() {
      this.changeType(this.type);
    },
    changeType(type) {
      this.type = type;
      this.orderList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      this.getOrderList();
    },
    getOrderList() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const { page, limit } = this;
      hxOrderLog({
        page,
        limit,
        data:
          this.bussAuthEndTime && this.certStartTime
            ? this.certStartTime + " - " + this.bussAuthEndTime
            : ""
      }).then(res => {
        this.orderList = this.orderList.concat(res.data);
        this.page++;
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      });
    },
    // getStatus(order) {
    //   return STATUS[order._status._type];
    // },
    cancelOrder(order) {
      cancelOrderHandle(order.order_id)
        .then(() => {
          this.getOrderData();
          this.orderList.splice(this.orderList.indexOf(order), 1);
        })
        .catch(() => {
          this.reload();
        });
    },
    paymentTap: function(order) {
      var that = this;
      if (
        !(
          order.combination_id > 0 ||
          order.bargain_id > 0 ||
          order.seckill_id > 0
        )
      ) {
        that.setOfflinePayStatus(order.offlinePayStatus);
      }
      this.pay = true;
      this.toPay = type => {
        payOrderHandle(order.order_id, type, that.from)
          .then(() => {
            const type = parseInt(this.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          })
          .catch(res => {
            if (res.status === "WECHAT_H5_PAY")
              return that.$router.push({
                path: "/order/status/" + order.order_id + "/5"
              });
            const type = parseInt(that.$route.params.type) || 0;
            that.changeType(type);
            that.getOrderData();
          });
      };
    },
    toPay() {}
  },
  mounted() {
    // this.getOrderData();
    this.gethxOrderBadge();
    // this.User();
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  }
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

img {
  display: block;
  width: 100%;
  height: auto;
}

.flex.flex_between {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.flex.flex_around {
  justify-content: space-around;
  -webkit-justify-content: space-around;
}
.flex.ali_center {
  align-items: center;
  -webkit-align-items: center;
}
.flex.flex_center {
  justify-content: center;
  -webkit-justify-content: center;
}
.flex_col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
}
.DatetimePicker {
  height: 6rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 1000;
}
.DatetimePicker {
  height: 6rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 1000;
}
</style>
